"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CardFooter = _interopRequireDefault(require("./CardFooter"));

var _CardBody = _interopRequireDefault(require("./CardBody"));

var _CardHeader = _interopRequireDefault(require("./CardHeader"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CardContainer = function CardContainer(_ref) {
  var children = _ref.children;

  var getComponent = function getComponent(displayName) {
    return children.filter(function (comp) {
      return comp.props.displayName === displayName;
    });
  };

  return _react["default"].createElement("div", {
    className: "card",
    id: "best-card-container"
  }, children instanceof Array ? _react["default"].createElement(_react["default"].Fragment, null, getComponent("card-header"), getComponent("card-body"), getComponent("card-footer")) : _react["default"].createElement(_react["default"].Fragment, null, children));
};

CardContainer.Header = _CardHeader["default"];
CardContainer.Body = _CardBody["default"];
CardContainer.Footer = _CardFooter["default"];
CardContainer.propTypes = {
  /** Children to display */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = CardContainer;
exports["default"] = _default;